import { render, staticRenderFns } from "./AllClassifiedPapasMergeQuestionsInsight.vue?vue&type=template&id=0a98329a&scoped=true"
import script from "./AllClassifiedPapasMergeQuestionsInsight.vue?vue&type=script&lang=js"
export * from "./AllClassifiedPapasMergeQuestionsInsight.vue?vue&type=script&lang=js"
import style0 from "./AllClassifiedPapasMergeQuestionsInsight.vue?vue&type=style&index=0&id=0a98329a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a98329a",
  null
  
)

export default component.exports